import React, { useEffect, useState } from 'react'
import ArticleSlider from '../../Components/ArticleSlider/ArticleSlider'
import CourseCategory from '../../Components/CourseCategory/CourseCategory'
import FreeCourse from '../../Components/FreeCourse/FreeCourse'
import GeneralCategory from '../../Components/GeneralCategory/GeneralCategory'
import GoldenOfferSlider from '../../Components/GoldenOfferSlider/GoldenOfferSlider'
import LandingComponent from '../../Components/LandingComponent/LandingComponent'
import PopularCoursesComponent from '../../Components/PopularCoursesComponent/PopularCoursesComponent'
import ProductSlider from '../../Components/ProductSlider/ProductSlider'
import SliderComment from '../../Components/SliderComment/SliderComment'
import TeacherIntroduction from '../../Components/TeacherIntroduction/TeacherIntroduction'
import { Helmet } from 'react-helmet-async'
export default function Home() {
  return (
    <>
      <Helmet>
        <title>سه نیک | سازمان علمی و آموزشی -کسب مهارت برای اشتغال  </title>
        <meta name='description' content='حاصل ده‌ها سال تجربه، تلاش، تحقیق و جمع آوری اطلاعات توسط آقای دکتر منوچهر مزداپور می‌باشد. هدف سه‌نیک همانطور که از نامش پیداست ترویج نیکی و کمک به یکدیگر برای رسیدن به جامعه‌ای مستقل و پویاست' />
      </Helmet>
      <LandingComponent />
      <GeneralCategory />
      <PopularCoursesComponent />
      <GoldenOfferSlider />
      <SliderComment />
      <FreeCourse />
      <CourseCategory />
      <TeacherIntroduction />
      <ProductSlider />
      <ArticleSlider />
    </>
  )
}
